import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "header-icons" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import NavHeader from '@/components/common/nav-header/NavHeader.vue';
import CustomTooltip from '@/components/common/tooltip/CustomTooltip.vue';
import RouteNames from '@/configuration/router/names.routes';
import { AssistantType, ChatAssistant } from '@/models/assistant-types';
import navigationService from '@/services/NavigationService';
import { useChatStore } from '@/stores/chat-store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatHeader',
  props: {
    assistant: {},
    resetConversation: {},
    showHistory: { type: Boolean, default: true },
    enableNewConversationButton: { type: Boolean, default: false },
    currentConversationId: {}
  },
  setup(__props: any) {

const chatStore = useChatStore();

const props = __props;

const navigateToHistory = (): void => {
  switch (props.assistant) {
    case AssistantType.LegalAssistant:
      navigationService.navigateTo({
        name: RouteNames.LegalHistory,
        params: { currentConversationId: props.currentConversationId }
      });
      break;
    default:
      navigationService.navigateTo({
        name: RouteNames.ReviewingHistory,
        params: { currentConversationId: props.currentConversationId }
      });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavHeader, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.enableNewConversationButton)
          ? (_openBlock(), _createBlock(CustomTooltip, {
              key: 0,
              message: _ctx.$t('legal_assistant.actions.new_conversation'),
              position: "bottom",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(AppIcon, {
                  name: "new-conversation",
                  size: "body-xl",
                  onclick: !_unref(chatStore).loading ? _ctx.resetConversation : null,
                  clickable: true
                }, null, 8, ["onclick"])
              ]),
              _: 1
            }, 8, ["message"]))
          : _createCommentVNode("", true),
        (_ctx.showHistory)
          ? (_openBlock(), _createBlock(CustomTooltip, {
              key: 1,
              message: _ctx.$t('legal_assistant.actions.go_history'),
              position: "bottom",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(AppIcon, {
                  name: "history",
                  size: "body-xl",
                  onclick: !_unref(chatStore).loading ? navigateToHistory : null,
                  clickable: true
                }, null, 8, ["onclick"])
              ]),
              _: 1
            }, 8, ["message"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})